import { makeRequest } from "src/services/restcall";
import { ApiResponse } from "src/services/types";
import HttpMethod from '../../services/httpMethods'


export async function postInactiveOrganizationParentAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/organization/organization-parent', value)
}
export async function getOrgObservationsAPI(filter:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization/organization-parent?organizationParentId='+filter, {})
}

export async function putPortfolioGEIAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/portfolio/gei-portafolio', value)
}

export async function postPortfolioGEIAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/portfolio/gei-portafolio', value)
}

export async function putPortfolioStatusGEIAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/portfolio/gei-portafolio-status', value)
}

export async function getPortfolioGEIAPI(page:number, pageSize:number,organizationId:string,filter:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/portfolio/gei-portafolio/'+page+"/"+pageSize+"?organizationId="+organizationId+"&filter="+filter, {})
}


export async function getPortfolioAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/portfolio?geiId='+value, {})
}

export async function postPortfolioAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/portfolio', value)
}

export async function putStatusPortfolioAPI(value:Object) : Promise<ApiResponse>{
    return await makeRequest(HttpMethod.PUT, '/api/portfolio/status', value)
}

export async function putPortfolioAPI(value: Object) : Promise<ApiResponse>{
    return await makeRequest(HttpMethod.PUT, '/api/portfolio', value)
}

export async function getActivityDataPortfolioAPI(value : string) : Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/portfolio/portfolioactivitydata?portfolioId=' + value, {})
}

export async function PostPortfolioActivityDataAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/portfolio/portfolioactivitydata', value)
}

export async function DeletePortfolioActivityDataAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/portfolio/portfolioactivitydata?portfolioActivityDataId=' + value, {})
}

export async function putPortfolioActivityDataAPI(value: Object) : Promise<ApiResponse>{
    return await makeRequest(HttpMethod.PUT, '/api/portfolio/portfolioactivitydata', value)
}